// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermosDeUsoRouteImport } from './routes/termos-de-uso'
import { Route as TerminosYCondicionesRouteImport } from './routes/terminos-y-condiciones'
import { Route as SobreRouteImport } from './routes/sobre'
import { Route as ResortsRouteImport } from './routes/resorts'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as QuienesSomosRouteImport } from './routes/quienes-somos'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PoliticaDePrivacidadRouteImport } from './routes/politica-de-privacidad'
import { Route as MyReservationsRouteImport } from './routes/my-reservations'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DirectorioHotelesRouteImport } from './routes/directorio-hoteles'
import { Route as CochesRouteImport } from './routes/coches'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ActividadesRouteImport } from './routes/actividades'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as HotelesIndexRouteImport } from './routes/hoteles.index'
import { Route as ProductoIdRouteImport } from './routes/producto.$id'
import { Route as HotelesHotelIdRouteImport } from './routes/hoteles.$hotelId'
import { Route as HotelSlugRouteImport } from './routes/hotel.$slug'
import { Route as DestinoSlugRouteImport } from './routes/destino.$slug'
import { Route as ResortsRegionSlugRouteImport } from './routes/resorts.$regionSlug'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout.success'
import { Route as CheckoutCancelRouteImport } from './routes/checkout.cancel'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminVerificationRouteImport } from './routes/admin.verification'
import { Route as AdminReservationsRouteImport } from './routes/admin.reservations'
import { Route as AdminProductsRouteImport } from './routes/admin.products'
import { Route as AdminPaymentsRouteImport } from './routes/admin.payments'
import { Route as AdminImagesAuditRouteImport } from './routes/admin.images-audit'
import { Route as AdminHotelsRouteImport } from './routes/admin.hotels'
import { Route as AdminDestinationsIndexRouteImport } from './routes/admin.destinations.index'
import { Route as AdminDestinationsNewRouteImport } from './routes/admin.destinations.new'
import { Route as AdminDestinationsIdRouteImport } from './routes/admin.destinations.$id'

const TermosDeUsoRoute = TermosDeUsoRouteImport.update({
            id: '/termos-de-uso',path: '/termos-de-uso',getParentRoute: () => rootRouteImport
          })
const TerminosYCondicionesRoute = TerminosYCondicionesRouteImport.update({
            id: '/terminos-y-condiciones',path: '/terminos-y-condiciones',getParentRoute: () => rootRouteImport
          })
const SobreRoute = SobreRouteImport.update({
            id: '/sobre',path: '/sobre',getParentRoute: () => rootRouteImport
          })
const ResortsRoute = ResortsRouteImport.update({
            id: '/resorts',path: '/resorts',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const QuienesSomosRoute = QuienesSomosRouteImport.update({
            id: '/quienes-somos',path: '/quienes-somos',getParentRoute: () => rootRouteImport
          })
const ProfileRoute = ProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => rootRouteImport
          })
const PoliticaDePrivacidadRoute = PoliticaDePrivacidadRouteImport.update({
            id: '/politica-de-privacidad',path: '/politica-de-privacidad',getParentRoute: () => rootRouteImport
          })
const MyReservationsRoute = MyReservationsRouteImport.update({
            id: '/my-reservations',path: '/my-reservations',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const DirectorioHotelesRoute = DirectorioHotelesRouteImport.update({
            id: '/directorio-hoteles',path: '/directorio-hoteles',getParentRoute: () => rootRouteImport
          })
const CochesRoute = CochesRouteImport.update({
            id: '/coches',path: '/coches',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const ActividadesRoute = ActividadesRouteImport.update({
            id: '/actividades',path: '/actividades',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const HotelesIndexRoute = HotelesIndexRouteImport.update({
            id: '/hoteles/',path: '/hoteles/',getParentRoute: () => rootRouteImport
          })
const ProductoIdRoute = ProductoIdRouteImport.update({
            id: '/producto/$id',path: '/producto/$id',getParentRoute: () => rootRouteImport
          })
const HotelesHotelIdRoute = HotelesHotelIdRouteImport.update({
            id: '/hoteles/$hotelId',path: '/hoteles/$hotelId',getParentRoute: () => rootRouteImport
          })
const HotelSlugRoute = HotelSlugRouteImport.update({
            id: '/hotel/$slug',path: '/hotel/$slug',getParentRoute: () => rootRouteImport
          })
const DestinoSlugRoute = DestinoSlugRouteImport.update({
            id: '/destino/$slug',path: '/destino/$slug',getParentRoute: () => rootRouteImport
          })
const ResortsRegionSlugRoute = ResortsRegionSlugRouteImport.update({
            id: '/$regionSlug',path: '/$regionSlug',getParentRoute: () => ResortsRoute
          })
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
            id: '/success',path: '/success',getParentRoute: () => CheckoutRoute
          })
const CheckoutCancelRoute = CheckoutCancelRouteImport.update({
            id: '/cancel',path: '/cancel',getParentRoute: () => CheckoutRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminVerificationRoute = AdminVerificationRouteImport.update({
            id: '/verification',path: '/verification',getParentRoute: () => AdminRoute
          })
const AdminReservationsRoute = AdminReservationsRouteImport.update({
            id: '/reservations',path: '/reservations',getParentRoute: () => AdminRoute
          })
const AdminProductsRoute = AdminProductsRouteImport.update({
            id: '/products',path: '/products',getParentRoute: () => AdminRoute
          })
const AdminPaymentsRoute = AdminPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => AdminRoute
          })
const AdminImagesAuditRoute = AdminImagesAuditRouteImport.update({
            id: '/images-audit',path: '/images-audit',getParentRoute: () => AdminRoute
          })
const AdminHotelsRoute = AdminHotelsRouteImport.update({
            id: '/hotels',path: '/hotels',getParentRoute: () => AdminRoute
          })
const AdminDestinationsIndexRoute = AdminDestinationsIndexRouteImport.update({
            id: '/destinations/',path: '/destinations/',getParentRoute: () => AdminRoute
          })
const AdminDestinationsNewRoute = AdminDestinationsNewRouteImport.update({
            id: '/destinations/new',path: '/destinations/new',getParentRoute: () => AdminRoute
          })
const AdminDestinationsIdRoute = AdminDestinationsIdRouteImport.update({
            id: '/destinations/$id',path: '/destinations/$id',getParentRoute: () => AdminRoute
          })





const AdminRouteChildren = {
  AdminHotelsRoute: AdminHotelsRoute,AdminImagesAuditRoute: AdminImagesAuditRoute,AdminPaymentsRoute: AdminPaymentsRoute,AdminProductsRoute: AdminProductsRoute,AdminReservationsRoute: AdminReservationsRoute,AdminVerificationRoute: AdminVerificationRoute,AdminIndexRoute: AdminIndexRoute,AdminDestinationsIdRoute: AdminDestinationsIdRoute,AdminDestinationsNewRoute: AdminDestinationsNewRoute,AdminDestinationsIndexRoute: AdminDestinationsIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const CheckoutRouteChildren = {
  CheckoutCancelRoute: CheckoutCancelRoute,CheckoutSuccessRoute: CheckoutSuccessRoute
}

const CheckoutRouteWithChildren = CheckoutRoute._addFileChildren(CheckoutRouteChildren)




const ResortsRouteChildren = {
  ResortsRegionSlugRoute: ResortsRegionSlugRoute
}

const ResortsRouteWithChildren = ResortsRoute._addFileChildren(ResortsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,ActividadesRoute: ActividadesRoute,AdminRoute: AdminRouteWithChildren,AuthRoute: AuthRoute,CheckoutRoute: CheckoutRouteWithChildren,CochesRoute: CochesRoute,DirectorioHotelesRoute: DirectorioHotelesRoute,FaqRoute: FaqRoute,MyReservationsRoute: MyReservationsRoute,PoliticaDePrivacidadRoute: PoliticaDePrivacidadRoute,ProfileRoute: ProfileRoute,QuienesSomosRoute: QuienesSomosRoute,ResetPasswordRoute: ResetPasswordRoute,ResortsRoute: ResortsRouteWithChildren,SobreRoute: SobreRoute,TerminosYCondicionesRoute: TerminosYCondicionesRoute,TermosDeUsoRoute: TermosDeUsoRoute,DestinoSlugRoute: DestinoSlugRoute,HotelSlugRoute: HotelSlugRoute,HotelesHotelIdRoute: HotelesHotelIdRoute,ProductoIdRoute: ProductoIdRoute,HotelesIndexRoute: HotelesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)